export const STATUS_UNPROCESSED = 1
export const STATUS_APPROVED = 2
export const STATUS_REJECTED = 3
export const STATUS_VOIDED = 4
export const STATUS_PREPARED = 10
